import isArray from "lodash/isArray";

function normStatus(status) {
  if (status == null) return "";
  const s = String(status).trim().toUpperCase();
  return s;
}

function extractDealsArray(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "object") return [];

  if (raw.dealGroup != null) {
    return isArray(raw.dealGroup) ? raw.dealGroup : [raw.dealGroup];
  }
  if (raw.deal != null) {
    return isArray(raw.deal) ? raw.deal : [raw.deal];
  }
  if (raw.deals != null) {
    const inner = raw.deals;
    if (Array.isArray(inner)) return inner;
    if (inner && typeof inner === "object") {
      if (inner.deal != null) {
        return isArray(inner.deal) ? inner.deal : [inner.deal];
      }
      if (inner.dealGroup != null) {
        return isArray(inner.dealGroup) ? inner.dealGroup : [inner.dealGroup];
      }
      return [inner];
    }
  }
  return [];
}

/**
 * מחזיר מערך עסקאות מתוך גוף התשובה של POST /searchLds (res.data או raw).
 * מקל על וריאציות של opStatus ומחלץ deal לפני סימון שגיאה אופרטיבית.
 *
 * @param {unknown} raw
 * @returns {{ deals: object[], isNoResults: boolean, opError: boolean }}
 */
export function normalizeLdsSearchDeals(raw) {
  if (raw == null) {
    return { deals: [], isNoResults: false, opError: false };
  }

  const asObj = typeof raw === "object" && !Array.isArray(raw) ? raw : null;
  const status = normStatus(asObj?.opStatus?.status);

  if (status === "NO_RESULTS") {
    return { deals: [], isNoResults: true, opError: false };
  }

  const deals = extractDealsArray(raw);
  if (deals.length > 0) {
    return { deals, isNoResults: false, opError: false };
  }

  if (status && status !== "SUCCESS") {
    return { deals: [], isNoResults: false, opError: true };
  }

  return { deals: [], isNoResults: false, opError: false };
}
